import { defineMessages } from 'react-intl-next';

export const messages: {
	firstDefaultItem: {
		defaultMessage: string;
		description: string;
		id: string;
	};
	linksMenuDescription: {
		defaultMessage: string;
		description: string;
		id: string;
	};
	linksMenuTitle: {
		defaultMessage: string;
		description: string;
		id: string;
	};
	lozengeTitle: {
		defaultMessage: string;
		description: string;
		id: string;
	};
	nestedDefaultItem: {
		defaultMessage: string;
		description: string;
		id: string;
	};
	secondDefaultItem: {
		defaultMessage: string;
		description: string;
		id: string;
	};
	thirdDefaultItem: {
		defaultMessage: string;
		description: string;
		id: string;
	};
} = defineMessages({
	linksMenuTitle: {
		id: 'company-hub.links-menu-extension.manifest.extension-title',
		defaultMessage: 'Links menu [New]',
		description:
			'Title of links menu extension to be displayed in toolbar/shortcut macros dropdown.',
	},
	lozengeTitle: {
		id: 'company-hub.links-menu-extension.manifest.extension-lozenge-title',
		defaultMessage: 'Links menu',
		description: 'Title of links menu extension to be displayed in lozenge',
	},
	linksMenuDescription: {
		id: 'company-hub.links-menu-extension.manifest.extension-description',
		defaultMessage: 'Add multiple links and sub-menus to Company Hub',
		description:
			'Description of links menu extension to be displayed in toolbar/shortcut macros dropdown',
	},
	firstDefaultItem: {
		id: 'company-hub.links-menu-extension.manifest.first-default-item',
		defaultMessage: 'About us',
		description: 'Title of first placeholder item on links menu rendered in extension',
	},
	secondDefaultItem: {
		id: 'company-hub.links-menu-extension.manifest.second-default-item',
		defaultMessage: 'Benefits',
		description: 'Title of second placeholder item on links menu rendered in extension',
	},
	thirdDefaultItem: {
		id: 'company-hub.links-menu-extension.manifest.third-default-item',
		defaultMessage: 'Teams',
		description: 'Title of third placeholder item on links menu rendered in extension',
	},
	nestedDefaultItem: {
		id: 'company-hub.links-menu-extension.manifest.nested-default-item',
		defaultMessage: 'Team 1',
		description:
			'Title of nested placeholder item inside the third menu item on links menu rendered in extension',
	},
});
